/** 領券／錢包頁樣式：全部用 px() 算出像素，避免 CSS calc(var(--u)) 在 LINE WebView 失效 */
import { resolveCouponClaimCode } from './couponLiff';

export function couponClaimStyles(px) {
  const p = (n) => `${px(n)}px`;
  return `
    .cc-box {
      position: absolute;
      left: ${p(90)};
      right: ${p(90)};
      top: ${p(300)};
      background: #f0dfd4;
      border: ${p(2)} solid #111;
      border-radius: ${p(30)};
      padding: ${p(40)} ${p(36)};
      text-align: center;
      box-shadow: 0 ${p(8)} ${p(24)} rgba(0,0,0,.12);
      max-height: ${p(1500)};
      overflow-y: auto;
      color: #111;
    }
    .cc-title { font-size: ${p(80)}; margin: 0 0 ${p(16)}; font-weight: 900; letter-spacing: -0.02em; }
    .cc-sub { font-size: ${p(40)}; margin: 0 0 ${p(16)}; opacity: .85; line-height: 1.35; }
    .cc-coupon-card {
      background: rgba(255,255,255,.72);
      border: ${p(2)} solid rgba(17,17,17,.12);
      border-radius: ${p(16)};
      padding: ${p(20)} ${p(18)};
      margin-bottom: ${p(24)};
      text-align: left;
    }
    .cc-coupon-name { font-size: ${p(52)}; font-weight: 900; margin-bottom: ${p(8)}; text-align: center; }
    .cc-coupon-desc { font-size: ${p(36)}; line-height: 1.5; white-space: pre-wrap; color: #374151; }
    .cc-steps { display: flex; align-items: center; justify-content: center; margin-bottom: ${p(28)}; }
    .cc-step { display: flex; flex-direction: column; align-items: center; min-width: ${p(140)}; }
    .cc-step-num {
      width: ${p(52)}; height: ${p(52)}; border-radius: 50%;
      border: ${p(3)} solid #bbb; background: #fff;
      display: flex; align-items: center; justify-content: center;
      font-size: ${p(28)}; font-weight: 900; color: #bbb;
    }
    .cc-step.on .cc-step-num { border-color: #111; color: #111; }
    .cc-step.cur .cc-step-num { background: #111; color: #fff; }
    .cc-step-label { font-size: ${p(26)}; margin-top: ${p(8)}; color: #888; }
    .cc-step.on .cc-step-label { color: #111; font-weight: 700; }
    .cc-step-line { flex: 1; height: ${p(3)}; background: #bbb; min-width: ${p(16)}; max-width: ${p(40)}; }
    .cc-step-line.on { background: #111; }
    .cc-form-block { text-align: left; margin-bottom: ${p(8)}; }
    .cc-form-label { display: block; font-size: ${p(32)}; font-weight: 800; margin-bottom: ${p(10)}; color: #111; }
    .cc-field-label { display: block; font-size: ${p(28)}; font-weight: 700; margin-bottom: ${p(8)}; color: #444; }
    .cc-phone-wrap { margin-bottom: ${p(16)}; }
    .cc-input {
      width: 100%; box-sizing: border-box; font-size: ${p(42)};
      padding: ${p(16)} ${p(18)}; border: ${p(2)} solid #111; border-radius: ${p(14)};
      margin-bottom: ${p(16)}; text-align: center; background: #fff;
    }
    .cc-input:focus { outline: none; box-shadow: 0 0 0 ${p(4)} rgba(17,17,17,.12); }
    .cc-otp { font-size: ${p(56)}; letter-spacing: ${p(10)}; font-weight: 900; padding: ${p(22)} ${p(14)}; }
    .cc-email-highlight { font-size: ${p(44)}; font-weight: 900; margin-bottom: ${p(20)}; word-break: break-all; }
    .cc-btn {
      width: 100%; font-size: ${p(44)}; font-weight: 900;
      padding: ${p(16)} ${p(18)}; border-radius: ${p(14)};
      border: ${p(2)} solid #111; cursor: pointer; margin-top: ${p(12)};
    }
    .cc-btn:disabled { opacity: .5; cursor: not-allowed; }
    .cc-btn-primary { background: #111; color: #fff; }
    .cc-btn-secondary { background: #fff; color: #111; }
    .cc-btn-line {
      background: #00B900; color: #fff; border-color: #00A000;
      box-shadow: 0 ${p(4)} ${p(12)} rgba(0,185,0,.25);
    }
    .cc-divider-or {
      margin: ${p(28)} 0 ${p(16)}; font-size: ${p(32)}; color: #666;
      display: flex; align-items: center; gap: ${p(12)};
    }
    .cc-divider-or::before, .cc-divider-or::after {
      content: ''; flex: 1; height: 1px; background: rgba(0,0,0,.18);
    }
    .cc-line-busy {
      font-size: ${p(38)}; color: #166534; margin: ${p(12)} 0 0;
      padding: ${p(12)} ${p(16)}; background: #dcfce7; border-radius: ${p(12)};
    }
    .cc-line-hint {
      font-size: ${p(32)}; color: #666; margin: ${p(8)} 0 0; line-height: 1.4;
    }
    .cc-line-status { margin-top: ${p(16)}; }
    .cc-line-actions {
      display: flex; flex-direction: column; gap: ${p(12)}; margin-top: ${p(16)};
    }
    .cc-msg {
      font-size: ${p(38)}; margin-top: ${p(20)}; line-height: 1.45;
      padding: ${p(14)} ${p(16)}; border-radius: ${p(12)};
    }
    .cc-msg.ok { color: #166534; background: #ecfdf5; border: 1px solid #bbf7d0; }
    .cc-msg.warn { color: #92400e; background: #fffbeb; border: 1px solid #fde68a; }
    .cc-msg.err { color: #b00020; background: #fef2f2; border: 1px solid #fecaca; }
    .cc-note { font-size: ${p(34)}; color: #7c2d12; margin: ${p(16)} 0; line-height: 1.45; }
    .cc-success-body { text-align: center; }
    .cqb-wrap { text-align: center; margin: ${p(16)} 0; }
    .cqb-card {
      display: inline-block; background: #fff;
      border: ${p(2)} solid rgba(17,17,17,.15); border-radius: ${p(16)};
      padding: ${p(20)}; box-shadow: 0 ${p(4)} ${p(16)} rgba(0,0,0,.06);
    }
    .cqb-canvas { display: block; max-width: 100%; height: auto; }
    .cqb-claim-id { margin-top: ${p(16)}; font-weight: 900; letter-spacing: .04em; }
  `;
}

/** 從 URL 解析 coupon code（委派至 resolveCouponClaimCode） */
export function readCouponCodeFromUrl() {
  return resolveCouponClaimCode();
}
